class UserList {
  constructor() {
    this.UserOid = [];
    this.UserName = [];
    this.FirstName = [];
    this.LastName = [];
    this.UserEmail = [];
    this.CreatedDate = [];
    this.UserType = [];
    //this.Roles= [][];
    this.Status = [];
    this.UserListResp = null;
    this.SearchUserListResp = null;
    this.selectedUser = null;
    this.firstUser = null;
    this.totalRecords = 0;
  }

  getUserOid(index) {
    return this.UserOid[index];
  }

  setUserOid(index, Oid) {
    this.UserOid[index] = Oid;
  }

  getUserName(index) {
    return this.UserName[index];
  }

  setUserName(index, Username) {
    this.UserName[index] = Username;
  }

  getFirstName(index) {
    return this.FirstName[index];
  }

  setFirstName(index, FirstName) {
    this.FirstName[index] = FirstName;
  }

  getLastName(index) {
    return this.LastName[index];
  }

  setLastName(index, LastName) {
    this.LastName[index] = LastName;
  }

  getUserEmail(index) {
    return this.UserEmail[index];
  }

  setUserEmail(index, UserEmail) {
    this.UserEmail[index] = UserEmail;
  }

  getCreatedDate(index) {
    return this.CreatedDate[index];
  }

  setCreatedDate(index, CreatedDate) {
    this.CreatedDate[index] = CreatedDate;
  }

  getUserType(index) {
    return this.UserType[index];
  }

  setUserType(index, UserType) {
    this.UserType[index] = UserType;
  }

  getStatus(index) {
    return this.Status[index];
  }

  setStatus(index, Status) {
    this.Status[index] = Status;
  }

  getUserListResp() {
    return this.UserListResp;
  }

  setUserListResp(UserListResp) {
    this.UserListResp = UserListResp;
  }

  getSearchUserListResp() {
    return this.SearchUserListResp;
  }

  setSearchUserListResp(SearchUserListResp) {
    this.SearchUserListResp = SearchUserListResp;
  }

  getSelectedUser() {
    return this.selectedUser;
  }

  setSelectedUser(selectedUser) {
    this.selectedUser = selectedUser;
  }

  getFirstUser() {
    return this.firstUser;
  }

  setFirstUser(firstUser) {
    this.firstUser = firstUser;
  }

  getTotalRecords() {
    return this.totalRecords;
  }

  setTotalRecords(totalRecords) {
    this.totalRecords = totalRecords;
  }

  resetUserList() {
    this.UserOid = [];
    this.UserName = [];
    this.FirstName = [];
    this.LastName = [];
    this.UserEmail = [];
    this.CreatedDate = [];
    this.UserType = [];
    //this.Roles= [][];
    this.Status = [];
    this.UserListResp = null;
    this.SearchUserListResp = null;
    this.selectedUser = null;
    this.firstUser = null;
    this.totalRecords = 0;
  }
}
export default new UserList();
